import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStep2 = createIcon({
  viewBox: '0 0 36 36',
  path: (
    <>
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#0D47A1" />
      <path
        d="M21.3311 21.896C21.5231 21.896 21.6725 21.944 21.7791 22.04C21.8858 22.136 21.9391 22.2693 21.9391 22.44C21.9391 22.8133 21.7365 23 21.3311 23H15.0591C14.8778 23 14.7285 22.9467 14.6111 22.84C14.4938 22.7227 14.4351 22.584 14.4351 22.424C14.4351 22.2213 14.5098 22.0453 14.6591 21.896L18.5151 17.656C19.0485 17.0587 19.4325 16.5253 19.6671 16.056C19.9125 15.576 20.0351 15.096 20.0351 14.616C20.0351 13.9973 19.8538 13.5227 19.4911 13.192C19.1391 12.8613 18.6378 12.696 17.9871 12.696C17.4751 12.696 16.9845 12.792 16.5151 12.984C16.0458 13.1653 15.5765 13.448 15.1071 13.832C14.9471 13.96 14.7978 14.024 14.6591 14.024C14.5418 14.024 14.4405 13.9707 14.3551 13.864C14.2698 13.7467 14.2271 13.608 14.2271 13.448C14.2271 13.224 14.3125 13.0427 14.4831 12.904C14.9205 12.4987 15.4538 12.1787 16.0831 11.944C16.7125 11.7093 17.3578 11.592 18.0191 11.592C19.0325 11.592 19.8378 11.8587 20.4351 12.392C21.0431 12.9253 21.3471 13.6453 21.3471 14.552C21.3471 15.2027 21.1978 15.8267 20.8991 16.424C20.6111 17.0213 20.1311 17.688 19.4591 18.424L16.2591 21.896H21.3311Z"
        fill="#0D47A1"
      />
    </>
  ),
});

export default IconStep2;
